import { IVideoBlockStyles } from '~/types/block-styles.types';
import { CXBaseBlock } from '~/components/ClientExperience/OneFlow/models/cx-base-block.model';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import type { FlowRevision } from '~/models/flow-revision.model';
import { IVideoBlockResponse } from '~/types/server.types';
import { StreamingPlatform } from '~/components/Builder/Block/VideoBlock/VideoBlock.types';
import { detectStreamingPlatformFromUrl } from '~/common/VideoBlock.utils';

export class CXVideoBlock extends CXBaseBlock {
    type: 'video_block';
    styles: IVideoBlockStyles;

    constructor(
        block: IVideoBlockResponse,
        flowRevison: FlowRevision<CXRootStore>,
        rootStore: CXRootStore
    ) {
        super(block, flowRevison, rootStore);
        this.type = block.type;
        this.styles = block.styles;
    }

    get videoLink() {
        return this.styles?.video_link.trim();
    }

    get isNoVideo() {
        return !this.videoLink;
    }

    get isVideoControlsOn() {
        return this.styles?.video_controls;
    }

    get isLoopOn() {
        return this.styles?.loop_forever;
    }

    get isLoomVideo() {
        return this.streamingPlatform === StreamingPlatform.Loom;
    }

    get isPicTimeVideo() {
        return this.streamingPlatform === StreamingPlatform.PicTime;
    }

    get streamingPlatform(): StreamingPlatform {
        if (!this.videoLink) {
            return null;
        }
        const url = this.videoLink;
        return detectStreamingPlatformFromUrl(url);
    }

    get isTransparentBackgroundOn() {
        if (!this.isPicTimeVideo) {
            return false;
        }
        return this.styles.is_transparent_background;
    }

    get isAutoplayOn() {
        return this.styles?.auto_play;
    }

    get isMuted() {
        return this.isAutoplayOn;
    }

    get isPlaying() {
        return this.isAutoplayOn;
    }

    get loaderColor() {
        return this.rootStore.clientPortalConfigStore?.brandColor;
    }
}
